import React, { useState } from "react";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { Button } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import CardBox from "components/CardBox/index";
import MediaModal from "./mediaModal";

const TableAdverseReaction = ({
  data,
  handleOpenCRU,
  setCurrentRowObj,
  loadTable,
}) => {
  const [openFile, setFileOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const closeFileModal = () => {
    setFileOpen(false);
  };
  const openFileModal = (obj) => {
    setCurrentRow(obj);
    setFileOpen(true);
  };

  const datatableConfig = {
    textLabels: {
      body: {
        noMatch: "No hay resultados para la búsqueda actual",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordernar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Items por pagina:",
        displayRows: "de",
      },
      toolbar: {
        search: "Busqueda",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro",
      },
      filter: {
        all: "Todos",
        title: "FILTRO",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas",
      },
      selectedRows: {
        text: "item(s) seleccionados",
        delete: "Borrar",
        deleteAria: "Borrar filas seleccionadas",
      },
    },
  };

  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: datatableConfig.textLabels,
  };

  const handleClick = (tableMeta) => {
    handleOpenCRU();
    setCurrentRowObj(
      !tableMeta ? null : tableMeta.tableData[tableMeta.rowIndex]
    );
  };

  const columns = [
    {
      name: "productName",
      label: IntlGetText("AdverseReaction.product"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "typeTx",
      label: IntlGetText("AdverseReaction.type"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "eventDateTx",
      label: IntlGetText("AdverseReaction.date"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "description",
      label: IntlGetText("AdverseReaction.description"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "outcomeTx",
      label: IntlGetText("AdverseReaction.outcome"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowData = tableMeta.tableData[tableMeta.rowIndex];

          if (rowData.outcomeId === 1 || rowData.outcomeId === 2) {
            return (
              <div>
                <Button
                  onClick={() => openFileModal(rowData)}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-file"></i>
                </Button>
              </div>
            );
          }

          return (
            <div>
              <Button
                onClick={() => handleClick(tableMeta)}
                variant="contained"
                className="jr-btn jr-btn-xs"
              >
                <i className="zmdi zmdi-edit"></i>
              </Button>
              <div>
                <Button
                  onClick={() => openFileModal(rowData)}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-file"></i>
                </Button>
              </div>
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <MUIDataTable
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
        <Button
          onClick={() => handleClick(null)}
          variant="contained"
          color="primary"
        >
          {<IntlMessages id="core.add" />}
        </Button>
      </div>
      <MediaModal
        open={openFile}
        loadTable={loadTable}
        handleRequestClose={closeFileModal}
        rowObj={currentRow}
      />
    </div>
  );
};

export default TableAdverseReaction;
